import { render, staticRenderFns } from "./formChoose.vue?vue&type=template&id=72e36ba4&"
import script from "./formChoose.vue?vue&type=script&lang=js&"
export * from "./formChoose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports